import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const TickIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="tick-icon"
    width="8px"
    height="6px"
    viewBox="0 0 8 6"
    fill="none"
    {...props}
  >
    <path
      d="M0.5 2.99998L2.62132 5.1213L6.86396 0.878662"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
